<div class="main">
    <div class="section">
        <div class="head">
            <div class="label">
                {{'driverPath.driverPath' | translate}} - {{parentData.driverName}}
                <i class="material-icons" (click)="closeDialog();">
                    clear
                </i>
            </div>
        </div>
        <div class="body">
            <div class="form">
                <div class="inputContainer">
                    <div class="label">
                        {{'driverPath.from' | translate}}
                    </div>
                    <input type="text" [placeholder]="'driverPath.date' | translate" [(ngModel)]="from.date"
                        (click)="fromDate.open();" [matDatepicker]="fromDate">
                    <mat-datepicker #fromDate (closed)="setDateTime(from);fromTime.open()"></mat-datepicker>
                    <input type="text" [placeholder]="'driverPath.time' | translate" [(ngModel)]="from.time"
                        (click)="fromTime.open();" [ngxTimepicker]="fromTime">
                    <ngx-material-timepicker class="timePick" #fromTime (closed)="setDateTime(from)">
                    </ngx-material-timepicker>
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{'driverPath.to' | translate}}
                    </div>
                    <input type="text" [placeholder]="'driverPath.date' | translate" [(ngModel)]="to.date"
                        (click)="toDate.open();" [matDatepicker]="toDate">
                    <mat-datepicker #toDate (closed)="setDateTime(to);toTime.open()"></mat-datepicker>
                    <input type="text" [placeholder]="'driverPath.time' | translate" [(ngModel)]="to.time"
                        (click)="toTime.open();" [ngxTimepicker]="toTime">
                    <ngx-material-timepicker class="timePick" #toTime (closed)="setDateTime(to)">
                    </ngx-material-timepicker>
                </div>
                <div class="submitButton">
                    <div class="button" (click)="fetchPath();">
                        {{'driverPath.submit' | translate}}
                    </div>
                </div>
            </div>
            <div class="mapButtons">
                <div class="modeButton" style="margin-left: 215px;">
                    <div class="button" *ngIf="gpsLength"
                        [ngStyle]="{'background-color': gpsMode? '#631d50':'#e4e4e4' , 'color': gpsMode? '#fff' : '#000'}"
                        (click)="simMode = false; appMode = false; gpsMode = true;drawPath();">
                        <img *ngIf="!gpsMode" src="assets/gps.svg" alt=""><img *ngIf="gpsMode"
                            src="assets/gps-white.svg" alt=""><span class="label">Gps</span>

                    </div>
                </div>
                <div class="modeButton">
                    <div class="button" *ngIf="simLength"
                        [ngStyle]="{'background-color': simMode? '#631d50':'#e4e4e4' , 'color': simMode? '#fff' : '#000'}"
                        (click)="simMode = true; appMode = false;gpsMode = false;drawPath();">
                        <img *ngIf="!simMode" src="assets/sim.svg" alt=""><img *ngIf="simMode"
                            src="assets/sim-white.svg" alt=""><span class="label">Sim</span>

                    </div>
                </div>
                <div class="modeButton">
                    <div class="button" *ngIf="appLength"
                        [ngStyle]="{'background-color': appMode? '#631d50':'#e4e4e4' , 'color': appMode? '#fff' : '#000'}"
                        (click)="simMode = false; appMode = true;gpsMode = false;drawPath();">
                        <img *ngIf="!appMode" src="assets/app.svg" alt=""><img *ngIf="appMode"
                            src="assets/app-white.svg" alt=""><span class="label">App</span>

                    </div>
                </div>
                <div class="message" *ngIf="submit && !appLength && !simLength && !gpsLength">
                    {{'driverPath.message' | translate}}
                </div>
            </div>
            <div class="map" id="pathMap"></div>
        </div>
    </div>
</div>